export default "/images/80de33a72bd95978bd5e98f453de725f.png";